module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/item-1-caa3c22856e63da0cacc22ca97e18987.jpg";